import React from 'react';
import { useDispatch } from 'react-redux';

import { addVoucher } from 'Redux/ducks/voucher';
import imgixConfig from 'Config/imgix';

import 'Components/Product/ProductOffers/CouponBannerOffer.scss';

export default function CouponBannerOffer() {
  const dispatch = useDispatch();

  const imgSrcMobile = 'https://fanatical.imgix.net/production/assets/banners/lunar-new-year-sale-2025-fantasyverse-discount-banner.jpg';

  return (
    <div className="offer-banner preorder-bonus-banner-img">
      <button className="CouponBannerOffer" onClick={() => { dispatch(addVoucher('STRIKE20', null, true)); }}>
        <img
          srcSet={`
            ${imgSrcMobile}?${imgixConfig}&w=1292&h=340&fit=crop 1292w,
            ${imgSrcMobile}?${imgixConfig}&w=704&h=185&fit=crop 704w,
            ${imgSrcMobile}?${imgixConfig}&w=646&h=170&fit=crop 646w,
            ${imgSrcMobile}?${imgixConfig}&w=578&h=144&fit=crop 578w,
            ${imgSrcMobile}?${imgixConfig}&w=524&h=138&fit=crop 524w,
            ${imgSrcMobile}?${imgixConfig}&w=460&h=121&fit=crop 460w
          `}
          sizes="(min-width: 1520px) 646px, (min-width: 1200px) 578px, (min-width: 992px) 460px, (min-width: 768px) 704px, (min-width: 576px) 524px, 95vw"
          src={`${imgSrcMobile}?${imgixConfig}&w=646&h=170&fit=crop`}
          alt="Lunar New Year Sale | Get 20% off FantasyVerse before it slithers away! | Use code STRIKE20 | Click to apply"
        />
      </button>
    </div>
  );
}
